import AuthUser from '../utils/AuthUser'

// "async" is optional
export default async ({ app, router, Vue }) => {
  Vue.prototype.$auth = new AuthUser()
}
